import styled from 'styled-components';

// Higiene 2026-07-07 (Task 1 refactor): `Container` (flex-column/gap, sin
// padding) y `EmptyState` (div, distinto de InfoMessage por elemento y
// propiedades) difieren en CSS real de sus homónimos consolidados en
// ../../components/MainStyledComponents — quedan locales.

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.l};
  width: 100%;
`;

export const EmptyState = styled.div`
  padding: ${({ theme }) => theme.spacing.xxl};
  text-align: center;
  color: ${({ theme }) => theme.colors.greyDark};
  font-size: ${({ theme }) => theme.fontSize.M};
`;
